// extracted by mini-css-extract-plugin
export var closeButton = "comparisonHeader-module--closeButton--5ce65";
export var comparisonHeader = "comparisonHeader-module--comparisonHeader--c09b7";
export var headerBg = "comparisonHeader-module--headerBg--6e558";
export var headline = "comparisonHeader-module--headline--ac697";
export var leftContent = "comparisonHeader-module--leftContent--f20fc";
export var logo = "comparisonHeader-module--logo--0351f";